import { useState, useId } from "react";

function CardWithHeader({
  icon = "bi bi-person-circle",
  title,
  description,
  children,
  show,
}) {
  const [open, setOpen] = useState(true);
  const contentId = useId();
  const labelId = useId();

  if (!show) {
    return null;
  }

  return (
    <div className="card-with-header-root">
      <style>{`
        .card-with-header-root .card-with-header-btn:focus-visible {
          outline: 2px solid var(--bs-primary, #0d6efd);
          outline-offset: 2px;
        }
      `}</style>
      <div
        className="bg-white overflow-hidden border-2 border-start-primary"
        style={{
          borderRadius: "12px",
          boxShadow: "0 1px 3px rgba(0,0,0,0.06)",
          border: "1px solid rgba(0,0,0,0.06)",
          transition: "box-shadow 0.2s ease, border-color 0.2s ease",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.08)";
          e.currentTarget.style.borderColor = "rgba(0,0,0,0.1)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.boxShadow = "0 1px 3px rgba(0,0,0,0.06)";
          e.currentTarget.style.borderColor = "rgba(0,0,0,0.06)";
        }}
      >
        <button
          type="button"
          id={labelId}
          aria-expanded={open}
          aria-controls={contentId}
          className="card-with-header-btn w-100 border-0 bg-transparent text-start d-flex align-items-center justify-content-between gap-3 px-4 py-3"
          style={{
            cursor: "pointer",
            transition: "background 0.15s ease, outline 0.15s ease",
          }}
          onClick={() => setOpen(!open)}
          onMouseEnter={(e) => {
            e.currentTarget.style.background = "rgba(0,0,0,0.03)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = "transparent";
          }}
          onMouseDown={(e) => {
            e.currentTarget.style.background = "rgba(0,0,0,0.06)";
          }}
          onMouseUp={(e) => {
            e.currentTarget.style.background = "rgba(0,0,0,0.03)";
          }}
        >
          <div className="d-flex align-items-center gap-3 flex-grow-1 min-w-0">
            <i
              className={icon}
              style={{
                fontSize: "1.25rem",
                color: "var(--bs-body-color)",
                opacity: 0.85,
              }}
              aria-hidden
            />
            <div className="d-flex flex-column gap-0 min-w-0">
              <span
                className="fw-semibold m-0 text-body lh-tight text-truncate"
                style={{ fontSize: "0.9375rem" }}
              >
                {title}
              </span>
              {description && (
                <span
                  className="text-muted mt-0"
                  style={{ fontSize: "0.8125rem", lineHeight: 1.35 }}
                >
                  {description}
                </span>
              )}
            </div>
          </div>
          <span
            className="d-flex align-items-center gap-1 flex-shrink-0 text-muted"
            style={{ fontSize: "0.75rem" }}
          >
            <span style={{ opacity: open ? 0.7 : 1 }}>
              {open ? "Collapse" : "Expand"}
            </span>
            <i
              className="bi bi-chevron-down"
              style={{
                fontSize: "0.7rem",
                transition: "transform 0.2s ease",
                transform: open ? "rotate(180deg)" : "rotate(0deg)",
              }}
              aria-hidden
            />
          </span>
        </button>

        <div
          id={contentId}
          role="region"
          aria-labelledby={labelId}
          aria-hidden={!open}
          style={{
            display: "grid",
            gridTemplateRows: open ? "1fr" : "0fr",
            transition: "grid-template-rows 0.25s ease",
          }}
        >
          <div
            style={{
              overflow: "hidden",
              minHeight: 0,
            }}
          >
            <div
              className="px-4 py-3"
              style={{
                borderTop: "1px solid rgba(0,0,0,0.06)",
                fontSize: "0.9375rem",
              }}
            >
              {children}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CardWithHeader;
